import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaSpinner } from "react-icons/fa";
import { LuPhone } from "react-icons/lu";
import { toast } from "react-toastify";
import { useChangePasswordtOtpSendMutation } from "../../../Redux/Api/Signup";
import useCiT from "../../../common/ci/i18n";
import { AuthField, AuthHeading, AuthShell } from "../AuthShell";

/** Password bhool gaye — step 1: number daalo, OTP aayega. */
const RequestOTP: React.FC = () => {
  const t = useCiT();
  const navigate = useNavigate();
  const [mutation, { data, isLoading, isSuccess, isError, error }] =
    useChangePasswordtOtpSendMutation();
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [fieldError, setFieldError] = useState<string>("");

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!/^[6-9]\d{9}$/.test(phoneNumber)) {
      setFieldError(t("10 ank ka sahi mobile number daalein"));
      return;
    }
    setFieldError("");
    mutation({ phoneNumber });
  };

  useEffect(() => {
    if (isSuccess) {
      toast.success(data?.message || t("OTP bhej diya"));
      if (!localStorage.getItem("otpTimerStart2")) {
        localStorage.setItem("otpTimerStart2", Date.now().toString());
      }
      navigate("/forgot-password/verify-otp", { state: { phoneNumber } });
    } else if (isError) {
      toast.error(error?.data?.message || t("Kuch galat ho gaya"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, isError]);

  return (
    <AuthShell standalone>
      <form onSubmit={handleSubmit} noValidate>
        <AuthHeading
          title={t("Password bhool gaye?")}
          sub={t("Apna registered mobile number daalein — us par 6 ank ka OTP bhejenge.")}
        />

        <AuthField
          label={t("Mobile number")}
          name="phoneNumber"
          type="tel"
          inputMode="numeric"
          autoComplete="tel"
          maxLength={10}
          prefix="+91"
          placeholder="98xxxxxxxx"
          icon={<LuPhone size={18} />}
          value={phoneNumber}
          onChange={(e) => {
            setPhoneNumber(e.target.value.replace(/\D/g, "").slice(0, 10));
            setFieldError("");
          }}
          error={fieldError}
        />

        <button
          type="submit"
          disabled={isLoading}
          className="mt-5 inline-flex h-[52px] w-full items-center justify-center gap-2 rounded-md border border-ci-orange bg-ci-orange text-[17px] font-bold uppercase tracking-wide text-white transition hover:border-ci-orange2 hover:bg-ci-orange2 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {isLoading ? (
            <>
              <FaSpinner className="animate-spin" />
              {t("OTP bhej rahe hain…")}
            </>
          ) : (
            t("OTP bhejein")
          )}
        </button>

        <p className="mt-4 text-center text-[14px] text-ci-muted">
          {t("Password yaad aa gaya?")}{" "}
          <Link to="/signup" className="font-semibold text-ci-navy underline underline-offset-2">
            {t("Sign in karein")}
          </Link>
        </p>
      </form>
    </AuthShell>
  );
};

export default RequestOTP;
